export const TYPES = [
    'content',
    'content-md',
    'content-sm',
    'thumb',
    'blog-cover',
    'blog-card',
    'background',
];

export const FIT_TYPES = ['cover', 'contain', 'fill', 'none', 'scale-down'];

export default {};
